import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ReactNode } from 'react';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // Don't refetch on window focus by default
      staleTime: 1000 * 60 * 5, // Consider data fresh for 5 minutes
      retry: 0,
    },
  },
});

type QueryProviderProps = {
  children: ReactNode;
};

/**
 * Provider component for TanStack Query
 * Wrap your app with this component to enable React Query
 */
export const QueryProvider = ({ children }: QueryProviderProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* Show React Query Devtools only in development */}
      {import.meta.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
};

// Export the query client for direct access if needed
export { queryClient };
